import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';
import { useNoticeBusy } from './Notice';

export function Dialog({ title, onClose, children, footer, wide = false, large = false, roomy = false }: { title: string; onClose: () => void; children: ReactNode; footer?: ReactNode; wide?: boolean; large?: boolean; roomy?: boolean }) {
  const busy = useNoticeBusy();
  const width = large ? 'max-w-7xl' : wide ? 'max-w-6xl' : 'max-w-4xl';
  function requestClose() {
    if (busy) return;
    onClose();
  }
  return (
    <div className="fixed inset-0 z-50 flex items-end bg-gray-900/40 md:items-center md:justify-center md:p-4" onMouseDown={(event) => { if (event.target === event.currentTarget) requestClose(); }}>
      <div className={`flex max-h-[92vh] w-full ${width} ${roomy ? 'md:min-h-[78vh]' : ''} flex-col overflow-hidden rounded-t-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900 md:rounded-2xl`}>
        <div className="mx-auto mt-2 h-1 w-10 shrink-0 rounded-full bg-gray-300 md:hidden dark:bg-gray-600" />
        <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-4 dark:border-gray-700 md:px-6">
          <h3 className="min-w-0 flex-1 truncate text-lg font-semibold">{title}</h3>
          <Button variant="ghost" size="icon" className="shrink-0" aria-label="Close" onClick={requestClose}><X className="h-4 w-4" /></Button>
        </div>
        <div className="flex-1 space-y-4 overflow-y-auto px-4 py-5 md:px-6">{children}</div>
        {footer ? <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-4 dark:border-gray-700 md:flex-row md:justify-end md:px-6 [&>button]:max-md:w-full">{footer}</div> : null}
      </div>
    </div>
  );
}
